export default {
  namespaced: true,
  state: {
    socials: [
      {
        icon: 'vk',
        link: '#',
      },
      {
        icon: 'facebook',
        link: '#',
      },
      {
        icon: 'instagram',
        link: '#',
      },
      {
        icon: 'telegram',
        link: '#',
      },
    ],
  },
  getters: {
    socials: (state) => (quantity) => (quantity ? state.socials.slice(0, quantity) : state.socials),
  },
};
